<template>
    <div class="recharge-card-checkout py-3">
        <!-- <div class="strong-text--text medium-text text-center mb-8">
            أدخل الكود الموجود على بطاقة الشحن:
        </div> -->
        <v-form ref="form">
            <v-text-field v-model="code" :disabled="loading" :rules="[rules.required]" prepend-inner-icon="mdi-credit-card-outline" class="code-input" color="primary" outlined hide-details placeholder="كود بطاقة الشحن" label="كود الشحن"></v-text-field>
        </v-form>

        <div class="w-100 mt-5">
            <v-btn block :disabled="loading" :loading="loading" depressed color="primary" :dark="!loading" large @click="submit">
                <v-icon size="24" left>mdi-cash-check</v-icon>
                <strong>إتمام الدفع</strong>
            </v-btn>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        
    },
    data(){
        return {
            loading: false,
            code: '',

            rules: {
                required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
            },
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    methods: {
        ...GlobalMethods,
        submit(){
            if (!this.loading){
                if (this.$refs.form.validate()){
                    this.loading = true;

                    this.$store.dispatch('rechargeByRechargeCard', {code: this.code}).then(response=>{
                        this.loading = false;
                        this.showMsg('تم شحن البطاقة وإضافة الرصيد لمحفظتك بنجاح', 'success');

                        this.$emit('done');

                    }).catch(err=>{
                        this.loading = false;                        
                        if (err && err.response && err.response.data){
                            const msg = err.response.data,
                                status = err.response.status;
                            if (msg === 'INVALID_PAYCARD_CODE'){
                                this.showMsg('كود بطاقة الدفع غير صحيح', 'error');
                            }else if (msg === 'USED_PAYCARD'){
                                this.showMsg('البطاقة مُستخدمة سابقاً', 'error');
                            }else if (msg === 'EXPIRED_PAYCARD'){
                                this.showMsg('البطاقة منتهية الصلاحية', 'error');
                            }else if (msg && msg.message){
                                this.showMsg(msg.message, 'error');
                            }else{
                                this.showMsg('حدثت مشكلة أثناء تنفيذ طلبك', 'error');
                            }
                        }else{
                            this.showMsg('حدثت مشكلة أثناء تنفيذ طلبك', 'error');
                        }

                    })
                }else{
                    this.showMsg('من فضلك املأ الحقول المطلوبة', 'warning');
                }
            }
        }
    },
    mounted(){
        
    }
}
</script>

<style lang="scss">
.recharge-card-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}
</style>